import { useAuth } from '@/hooks'
import { useStore } from '@/store'
import { CategoriaEnum } from '@acme/auth'

interface IProps {
    children: React.ReactNode
    categorias?: CategoriaEnum[]
}

export default function DevelopmentOnly({ children, categorias }: IProps) {
    const { decoded } = useAuth()
    const isDebugToolsEnabled = useStore(state => state.isDebugToolsEnabled)

    if (!isDebugToolsEnabled) return null

    if (categorias && !categorias.includes(decoded?.categoria)) return null

    return children
}
